module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00484.f5944bf5.jpg";